/**
 * Normalizes line breaks in text by collapsing excessive consecutive line breaks
 * while preserving paragraph breaks (double line breaks).
 * 
 * Allows:
 * - Single line breaks (soft breaks within paragraphs)
 * - Double line breaks (paragraph breaks with blank line)
 * 
 * Prevents:
 * - Triple or more line breaks (excessive spacing)
 * 
 * @param text - The text to normalize
 * @returns The normalized text with at most double line breaks
 */
export function normalizeLineBreaks(text: string): string {
  if (!text) return text;
  
  // Replace 3 or more consecutive line breaks with double line break (paragraph break)
  return text.replace(/\n{3,}/g, '\n\n');
}
